module.exports = __webpack_public_path__ + "static/logo-sprite-@2x-87aa58de41a3347bb5fc1e8ad25c31b6.png";